import { useSuiStyles,SuiStylesType } from "baseStyles/useSuiStyles";
import Device from "baseStyles/enums/device";
import { Colors } from "baseStyles/enums/colors";
import { FlexBoxPropsType, FlexProps } from "schoolUiComponents/basic/Box/FlexBox/types";
import { TextPropsType } from "schoolUiComponents/basic/Text/types";

type StylesType = {
    scrollButton: FlexBoxPropsType
    newScrollButtonNext: FlexBoxPropsType
    newScrollButtonPrev: FlexBoxPropsType
}

const commonScrollStyles = {
    padding: 8,
    width: 32, 
    height: 32,
    borderRadius: '800px 800px 0 0',
    transition: true,
    center: true,
};

const Styles: SuiStylesType<{}, StylesType> = {
    [Device.types.Desktop]: ({ theme }) => {
        return {
            scrollButton: {
                padding: 6,
                width: 28, 
                height: 28,
                transition: true,
                center: true,
                round: true
            },
            newScrollButtonNext: {
                ...commonScrollStyles,
                transform: 'rotate(180deg)',
                boxShadow: '3px 0px 0px 0px rgba(0,0,0,0.25) inset'
            },
            newScrollButtonPrev: {
                ...commonScrollStyles,
                boxShadow: '-3px 0px 0px 0px rgba(0,0,0,0.25) inset'
            }
        }
    },
    [Device.types.Tablet]: ({ theme }) => {
        return {
            scrollButton: {
                width: 26, 
                height: 26
            },
            newScrollButtonNext: {
                ...commonScrollStyles,
                height: 30,
                width: 30,
                transform: 'rotate(180deg)',
                boxShadow: '3px 0px 0px 0px rgba(0,0,0,0.25) inset'
            },
            newScrollButtonPrev: {
                ...commonScrollStyles,
                height: 30,
                width: 30,
                boxShadow: '-3px 0px 0px 0px rgba(0,0,0,0.25) inset'
            }
        }
    }
}

const ScrollerStyles = useSuiStyles(Styles);

export default ScrollerStyles;